import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Navbar.css';

function Navbar({ isAuthenticated, onLogout }) {
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogout = () => {
        onLogout();
        navigate('/login');
    };

    const isActive = (path) => location.pathname === path;

    return (
        <nav className="navbar">
            <div className="navbar-inner">
                <div className="navbar-logo-wrap" onClick={() => navigate('/')}>
                    <img
                        className="navbar-logo-image"
                        src="/android-chrome-192x192.png"
                        alt="NoManual logo"
                    />
                    <div className="navbar-logo">NoManual Shop</div>
                </div>

                <ul className="navbar-links">
                    {isAuthenticated ? (
                        <>
                            <li>
                                <Link className={isActive('/') ? 'nav-link active' : 'nav-link'} to="/">
                                    Каталог
                                </Link>
                            </li>
                            <li>
                                <Link className={isActive('/cart') ? 'nav-link active' : 'nav-link'} to="/cart">
                                    Корзина
                                </Link>
                            </li>
                            <li>
                                <Link className={isActive('/orders') ? 'nav-link active' : 'nav-link'} to="/orders">
                                    Заказы
                                </Link>
                            </li>
                            <li>
                                <button className="logout-btn" onClick={handleLogout}>
                                    Выйти
                                </button>
                            </li>
                        </>
                    ) : (
                        <>
                            <li>
                                <Link className={isActive('/login') ? 'nav-link active' : 'nav-link'} to="/login">
                                    Войти
                                </Link>
                            </li>
                            <li>
                                <Link className={isActive('/register') ? 'nav-link active' : 'nav-link'} to="/register">
                                    Регистрация
                                </Link>
                            </li>
                        </>
                    )}
                </ul>
            </div>
        </nav>
    );
}

export default Navbar;
